import { jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useMemo } from 'react';
import ReactDOM from 'react-dom';
import '../observable/index.js';
import { useObservable, Observable } from '../observable/observable.js';

function LayoutPortalRaw({ children, container }) {
    const ref = useObservable(container);
    return ref ? ReactDOM.createPortal(children, ref) : null;
}
const useLayoutPortal = () => {
    // We are using useRef as a replacement of useMemo for a single reason
    // using useRef doesn't require to pass this variable to dependencies array of other hooks
    const portalContainerRef = useRef(new Observable(null));
    const setPortalContainerRef = useCallback((ref) => {
        portalContainerRef.current.setState(ref);
    }, []);
    // To make it easier to deal with this component later on, we are stabilizing
    // the reference of this component, i.e. we are aiming to make that dependencies
    // array would be empty
    const Portal = useMemo(() => function Portal(props) {
        const { children } = props;
        return (jsx(LayoutPortalRaw, Object.assign({ container: portalContainerRef.current }, { children: children })));
    }, []);
    return [Portal, setPortalContainerRef];
};

export { LayoutPortalRaw, useLayoutPortal };
